/**
 * A command (v1's `ActionButton`). `primary` is the one main command of an
 * action bar, and it is filled; no other button is. An action in a row — "Log",
 * "Check in", "Practice" — is this button without `primary`: outlined (the look
 * standard, R7). `active` is a toggle that is on — a tint, so it never outranks
 * the primary.
 */
import type { ButtonHTMLAttributes } from "react";

import styles from "./ActionButton.module.css";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  primary?: boolean;
  active?: boolean;
}

export function ActionButton({ primary, active, className, ...rest }: Props) {
  const classes = [styles.button, primary && styles.primary, active && styles.active, className]
    .filter(Boolean)
    .join(" ");
  return <button type="button" {...rest} className={classes} aria-pressed={active} />;
}
